var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"division"},[_c('div',{staticClass:"line right"}),_c('div',{staticClass:"divisImg"},[_c('img',{staticClass:"img",attrs:{"src":`${this.$imgDomain}/www/HealthingCore/division.png`,"alt":""}})]),_c('div',{staticClass:"line left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }